import React, { useState, useEffect } from "react";
// import ChannelBoxProps from "../../Create_channel/Empty_Screen/Channels_List/ChannelBoxProps";
import "./feedDetail.css";
import Form from "react-bootstrap/Form";
import CreateChannelFirst from "../../Create_channel/Create_channel_screen/CreateChannelFirst";
import CommentList from "./CommentList";
import axios from "../../../../axios";
import PostImagePopup from "../total_community_post/recent_post Img/PostImagePopup";
import { IP } from "../../../../internalServer";
// import axios from "../../../axios";

const FeedDetail = ({ postId, setIsEdited, isEdited, setOpenPopup }) => {
  const [clickCreate, setClickCreate] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isCommented, setIsCommented] = useState(false);
  const [commentAttach, setCommentAttach] = useState();
  const [comment, setComment] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentDeleted, setCommentDeleted] = useState(false);
  const [currentCommentNumber, setCurrentCommentNumber] = useState(0);
  const [members, setMembers] = useState([]);
  const [visibleComments, setVisibleComments] = useState(5);
  const [communityId, setCommunityId] = useState();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 5,
  });

  const [isLoading, setIsLoading] = useState(false);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const UserInformation = JSON.parse(localStorage.getItem("UserInformation"));

  const [postCommeCommu, setPostCommeCommu] = useState({
    postByIds: {},
    communitys: {},
  });
  const { postByIds, communitys } = postCommeCommu;
  const getMembers = async (id) => {
    try {
      let res = await axios.get(`/api/v1/community/${id}/getMember`);
      setMembers(res.data.data.members);
    } catch (error) {
      console.log(error);
    }
  };

  const getPostCommeCommu = async () => {
    setIsLoading(true);
    try {
      const postByIds = await axios.get(`/api/v1/community/post/get/${postId}`);
      const communitys = await axios.get(
        `/api/v1/community/getByUserId/teacher/${teacher_id}`,
      );
      if (postByIds && communitys) {
        await getMembers(postByIds.data.data.community_id.id);
        setPostCommeCommu({
          postByIds: postByIds.data.data,
          communitys: communitys.data.data,
        });
        setCommunityId(postByIds.data.data.community_id.id);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPostCommeCommu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId, isEdited]);

  const getPostComme = async () => {
    try {
      setIsInProgress(true);
      const res = await axios.get(
        `/api/v1/community/post/${postId}/comment/get`,
        // `/api/v1/community/post/${state.post_id}/comment/get?_page=${page}&_limit=${limit}`
      );
      res && setComments((prev) => [...res.data.data]);
      // res.data.data.length < limit
      //   ? setAreMoreComments(false)
      //   : setAreMoreComments(true);
    } catch (error) {}
    setIsInProgress(false);
  };

  useEffect(() => {
    getPostComme();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId, commentDeleted]);

  // const handelComment = async (e) => {
  //   e?.preventDefault?.();
  //   setIsInProgress(!isInProgress);
  //   let newComment = {
  //     user_id: teacher_id,
  //     comment,
  //   };
  //   if (commentAttach) {
  //     const formData = new FormData();
  //     formData.append("name", commentAttach.name);
  //     formData.append("uploadfile", commentAttach);
  //     try {
  //       const res = await axios.post(
  //         `/api/v1/community/post/comment/upload`,
  //         formData
  //       );
  //       newComment.attachments = res.data.data;
  //     } catch (error) {}
  //   }
  //   try {
  //     const res = await axios.post(
  //       `/api/v1/community/post/${postId}/comment/create`,
  //       newComment
  //     );

  //     if (res) {
  //       setIsInProgress(false);
  //       setIsCommented(!isCommented);
  //       setComment("");
  //       setCommentAttach(null);
  //       setFilter({ ...filter, page: 1 });
  //       setComments([]);
  //       setCurrentCommentNumber(currentCommentNumber + 1);
  //       getPostComme();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setIsInProgress(false);
  //   }
  // };

  const handelComment = async (e) => {
    e?.preventDefault?.();

    const scrollY = window.scrollY;

    setIsInProgress(true);
    let newComment = {
      user_id: teacher_id,
      comment,
    };

    if (commentAttach) {
      const formData = new FormData();
      formData.append("name", commentAttach.name);
      formData.append("uploadfile", commentAttach);
      try {
        const res = await axios.post(
          `/api/v1/community/post/comment/upload`,
          formData,
        );
        newComment.attachments = res.data.data;
      } catch (error) {}
    }

    try {
      const res = await axios.post(
        `/api/v1/community/post/${postId}/comment/create`,
        newComment,
      );

      if (res) {
        setComment("");
        setCommentAttach(null);
        setFilter({ ...filter, page: 1 });
        setComments([]); // causes re-render
        setCurrentCommentNumber(currentCommentNumber + 1);
        await getPostComme(); // wait to fetch new data
        window.scrollTo(0, scrollY); // restore scroll
      }
    } catch (error) {
      console.log(error);
    }

    setIsInProgress(false);
  };

  const profilePicUrl =
    IP +
    UserInformation?.profile_pic?.replace(/^\.\/*/, "")?.replace(/^\/+/, "");

  return (
    <>
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        {Object.keys(postByIds).length > 0 ? (
          <div
            className="w-100 d-flex  gap-4"
            style={{ height: "calc(100vh - 140px)", overflow: "hidden" }}
          >
            <div
              className=" d-flex flex-column gap-1 orange-scrollBar"
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "white",
                overflow: "auto",
              }}
            >
              <div
                className="m-1 rounded-3"
                style={{ border: "2px solid #E5E5E5" }}
              >
                <PostImagePopup
                  setOpenPopup={setOpenPopup}
                  post={postByIds}
                  commentLength={currentCommentNumber}
                  members={members}
                  setIsEdited={setIsEdited}
                />
                <div className="d-flex gap-1 flex-row align-items-center p-2 gap-2">
                  {/* image */}

                  <img
                    src={
                      UserInformation?.profile_picture
                        ? profilePicUrl
                        : UserInformation.gender === "M"
                          ? "/images/Teacher_Male.jpg"
                          : UserInformation.gender === "F"
                            ? "/images/Teacher_Female.png"
                            : "/images/default-profile.png"
                    }
                    alt="icon"
                    className="profilePicImg"
                    style={{
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                    }}
                    onError={(e) => {
                      // This function will run if the image fails to load
                      if (UserInformation?.gender === "M") {
                        e.target.src = "/images/Teacher_Male.jpg";
                      } else if (UserInformation?.gender === "F") {
                        e.target.src = "/images/Teacher_Female.png";
                      } else {
                        e.target.src = "/images/default-profile.png";
                      }
                    }}
                  />

                  <div className="comment_box_container w-100">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Write Your Comment..."
                      className="comment_box"
                      value={comment}
                      maxLength={250}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() !== "" || value === "") {
                          setComment(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && comment.trim()) {
                          e.preventDefault();
                          handelComment();
                        }
                      }}
                      disabled={postByIds?.isDeleted}
                    />

                    <div className="attact_shear_icon">
                      <button
                        type="button"
                        className="border-0 bg-transparent p-0"
                        disabled={
                          !comment?.trim() ||
                          isInProgress ||
                          postByIds?.isDeleted
                        }
                        onClick={() => {
                          if (comment?.trim()) {
                            handelComment();
                          }
                        }}
                      >
                        <img
                          src="/images/send button.svg"
                          className="comment_attach_Icon px-3"
                          alt="Send"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              >
                {/* {comments &&
                  comments.length > 0 &&
                  comments.map((data) => (
                    <CommentList
                      key={data.id}
                      setIsCommented={setIsCommented}
                      isCommented={isCommented}
                      setIsInProgress={setIsInProgress}
                      isInProgress={isInProgress}
                      setComments={setComments}
                      currentCommentNumber={currentCommentNumber}
                      setCurrentCommentNumber={setCurrentCommentNumber}
                      filter={filter}
                      setFilter={setFilter}
                      commentData={data}
                      post_id={state.post_id}
                      members={members}
                      communityId={communityId}
                      post={postByIds}
                    />
                  ))} */}
                {/* {areMoreComments && (
                  <span
                    className="view_more_comments"
                    onClick={() => setFilter({ ...filter, page: page + 1 })}
                  >
                    View more comments
                  </span>
                )} */}
                {
                  <div>
                    {/* </form> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <small className="like_comment_shear_style ">
                        Comments({comments.length})
                      </small>
                      <div>
                        {/* Loader */}

                        {isInProgress && (
                          <img
                            className="comment_loader"
                            src="/gif/LoaderDot.gif"
                            alt=""
                          />
                        )}
                        <button
                          className="refresh"
                          onClick={async () => {
                            const scrollY = window.scrollY; // ⬅️ store current scroll
                            setComments([]);
                            setVisibleComments(4);
                            await getPostComme(); // ⬅️ wait for comments to load
                            window.scrollTo(0, scrollY); // ⬅️ restore scroll
                          }}
                        >
                          Refresh
                        </button>
                      </div>
                    </div>
                    <hr
                      style={{ border: "1px solid #D9D9D9", height: "1px" }}
                    />
                    <div
                      className={`comment_list_container ${
                        isInProgress && `comment_loader_background`
                      }`}
                    >
                      {comments
                        .slice(0, visibleComments)
                        .map((comment, index) => (
                          <CommentList
                            key={index}
                            setIsCommented={setIsCommented}
                            isCommented={isCommented}
                            setIsInProgress={setIsInProgress}
                            isInProgress={isInProgress}
                            setComments={setComments}
                            currentCommentNumber={currentCommentNumber}
                            setCurrentCommentNumber={setCurrentCommentNumber}
                            filter={filter}
                            setFilter={setFilter}
                            commentData={comment}
                            post_id={postId}
                            members={members}
                            communityId={communityId}
                            post={postByIds}
                            getPostComme={getPostComme}
                          />
                        ))}
                      {visibleComments < comments.length && (
                        <div className="d-flex align-items-center justify-content-center">
                          <span
                            className="view_more_comments"
                            onClick={() =>
                              setVisibleComments(visibleComments + 5)
                            } // Increase visible comments by 5
                          >
                            View more comments
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                }
              </div>
            </div>

            {/* css comes in channelBox.css */}
            {/* <div
              className="px-2 py-2  d-flex flex-column gap-4 "
              style={{ width: "25%", height: "100%", backgroundColor: "white" }}
            >
              <div
                className=" mt-2 channels_box rounded-3 py-3 px-2 w-100"
                style={{ backgroundColor: "#f8f9fb", overflow: "hidden" }}
              >
                <div className="mb-2 d-flex align-items-center justify-content-between channel_createBtn border-bottom border-3 pb-2">
                  <span className="channel_header">Channels</span>

                  <span
                    className="create_channel_btn"
                    onClick={(e) => setClickCreate(true)}
                  >
                    + Create channel
                  </span>
                </div>
                <div className="feed_channel_boxs">
                  {communitys &&
                    communitys.length > 0 &&
                    communitys.map((data) => (
                      <ChannelBox
                        key={data.id}
                        setActive={setActive}
                        setViewFirstInProgress={setViewFirstInProgress}
                        viewFirstInProgress={viewFirstInProgress}
                        communityData={data}
                      />
                    ))}
                </div>
              </div>
            </div> */}
          </div>
        ) : (
          <div
            // style={{ backgroundColor: "black" }}
            className="d-flex align-items-center justify-content-center w-full h-full"
          >
            <img
              height={"150px"}
              width={"150px"}
              src="/gif/LoaderDot.gif"
              alt=""
            />
          </div>
        )}
      </div>
      {clickCreate && <CreateChannelFirst change={setClickCreate} />}
    </>
  );
};

export default FeedDetail;
